@if (itemsWithJsonData.length) {
    <app-table
        [items]="itemsWithJsonData"
        [columns]="columns"
        translatePrefix="form.opz."
        [hideCheckboxes]="true"
        [resource]="resource"
        (detailCallback)="detail($event)"
        (deleteCallbackWithEvent)="delete($event)"
    >
        <ng-template pTemplate="printHeader"></ng-template>
        <ng-template pTemplate="print" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-print"
                (clickEvent)="print(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="copyHeader"></ng-template>
        <ng-template pTemplate="copy" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-copy"
                (clickEvent)="copy(item)"
            ></app-button>
        </ng-template>
    </app-table>
}
